<script setup lang="ts">
const app = useNuxtApp()
const storeIndex = useStoreIndex()

definePageMeta({ layout: 'layout-single' })

const pageData = { museumFixUrl: '/admin' }

const refData = reactive({
  loading: false,
  errorMessage: null,
  isSended: false,
  modelUserId: '',
})

const setHead = () => {
  const headTitle = 'パスワード再設定'

  // ぱんくず作成
  storeIndex.setBreadCrumbs([
    {
      text: headTitle,
      disabled: true,
    },
  ])

  useHead({ title: headTitle })
}

const onSubmit = async () => {
  refData.loading = true
  try {
    const res = await app.$PasswordApi.passwordSend({ mail: refData.modelUserId })
    if ((res.data as any).code !== 200000) {
      refData.errorMessage = '正しいID（メールアドレス）を入力してください。'
      refData.loading = false
      return
    }
  } catch (e) {
    refData.loading = false
    return
  }
  refData.isSended = true
  refData.loading = false
}

setHead()
</script>

<template>
  <div
    class="p-singlePage"
  >
    <h2 class="c-heading_page">
      パスワード再設定
    </h2>
    <template
      v-if="!refData.isSended"
    >
      <p class="c-heading_description">
        登録時に入力したIMメンバーID（メールアドレス）を入力してください。
        パスワード再設定のご案内をメールで送信します。
      </p>

      <a
        v-bind:href="pageData.museumFixUrl"
        target="_blank"
        class="c-heading_link"
      >
        展覧会情報の登録など、ミュージアム関係者のページはこちらです。
      </a>

      <div class="c-heading_error">
        <template
          v-if="refData.errorMessage"
        >
          {{ refData.errorMessage }}
        </template>
      </div>

      <div class="p-password">
        <ValidationForm
          ref="obs"
          v-slot:default="{ meta }"
        >
          <div class="p-password_inputBlock">
            <div class="p-password_inputBlock_labelRow">
              <div class="p-password_inputBlock_labelRow_text">
                IMメンバーID（メールアドレス)
              </div>
            </div>

            <ValidationTextField
              v-model="refData.modelUserId"
              name="IMメンバーID"
              variant="outlined"
              density="compact"
              rules="required|email"
            />
          </div>
          <div
            class="p-password_action"
          >
            <v-btn
              class="c-btn_formSubmit"
              v-bind:disabled="refData.loading || !meta.valid"
              color="primary"
              v-on:click="onSubmit"
            >
              <v-icon>mdi-login</v-icon>
              送信
            </v-btn>
          </div>
        </ValidationForm>
      </div>
    </template>
    <template
      v-else
    >
      <div class="p-password_block1">
        パスワード再設定のご案内を送信しました。
      </div>
      <div class="p-password_block2">
        受信したメールのURLをクリックすると、パスワードの再設定の画面が表示されます。
      </div>
      <div class="p-password_block2">
        メールが届かない場合は「迷惑メール」などのフォルダに入っているか、<br>または入力したメールアドレスが間違っている可能性があります。
      </div>
    </template>
    <v-overlay
      v-bind:model-value="refData.loading"
      scrim="#fff"
      opacity="0.7"
      absolute
    >
      <v-progress-circular
        indeterminate
        color="#000"
        size="48"
      />
    </v-overlay>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive" as *;

.p-password {
  width: 410px;
  margin: 0 auto;

  @include mq_down(sp) {
    width: 100%;
  }

  &_error {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
  }

  &_inputBlock {
    margin-top: 0;

    &_labelRow {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      &_text {
        font-size: 15px;
        font-weight: bold;
      }

      &_required {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 46px;
        height: 19px;
        margin-left: 9px;
        border-radius: 10px;
        background-color: var(--color_primary);
        color: var(--g_color_text_white);
        font-size: 13px;
      }
    }

    &_input {
      width: 410px;

      @include mq_down(sp) {
        width: 100%;
      }
    }
  }

  &_action {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }

  &_block1 {
    margin-top: 26px;
    font-size: 20px;
    font-weight: bold;
    text-align: center;

    @include mq_down(sp) {
      font-size: 18px;
      text-align: left;
    }
  }

  &_block2 {
    margin-top: 48px;
    font-size: 15px;
    text-align: center;

    @include mq_down(sp) {
      margin-top: 38px;
      text-align: left;
    }
  }
}
</style>
